export interface Notification {
  id: number;
  userId: number;
  title: string;
  titleKey?: string;
  message: string;
  messageKey?: string;
  type: NotificationType;
  priority: NotificationPriority;
  status: NotificationStatus;
  isRead: boolean;
  readDate?: Date;
  createdDate: Date;
  scheduledDate?: Date;
  expiresDate?: Date;
  metadata?: NotificationMetadata;
  relatedEntityType?: RelatedEntityType;
  relatedEntityId?: number;
  actionUrl?: string;
  actionText?: string;
  actionTextKey?: string;
  icon?: string;
  color?: string;
}

export enum NotificationType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  REMINDER = 'reminder',
  ALERT = 'alert',
  ANNOUNCEMENT = 'announcement',
  SYSTEM = 'system',
}

export enum NotificationPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent',
}

export enum NotificationStatus {
  PENDING = 'pending',
  SENT = 'sent',
  DELIVERED = 'delivered',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

export enum RelatedEntityType {
  REQUEST = 'request',
  INVOICE = 'invoice',
  ANNOUNCEMENT = 'announcement',
  BOOKING = 'booking',
  PET_REGISTRY = 'pet_registry',
  VENDOR = 'vendor',
  RESIDENT = 'resident',
  PROPERTY = 'property',
  SUPPORT_TICKET = 'support_ticket',
  USER = 'user',
  SYSTEM = 'system',
}

export interface NotificationMetadata {
  [key: string]: any;

  source?: string;
  category?: string;
  tags?: string[];
  attachments?: string[];
  customData?: Record<string, any>;
}

export interface NotificationTemplate {
  id: number;
  name: string;
  description?: string;
  type: NotificationType;
  titleTemplate: string;
  messageTemplate: string;
  isActive: boolean;
  createdDate: Date;
  updatedDate: Date;
  variables?: string[];
}

export interface NotificationSettings {
  id: number;
  userId: number;
  emailEnabled: boolean;
  smsEnabled: boolean;
  pushEnabled: boolean;
  inAppEnabled: boolean;
  notificationTypes: NotificationTypeSettings;
  quietHours: QuietHours;
  digestSettings: DigestSettings;
  createdDate: Date;
  updatedDate: Date;
}

export interface NotificationTypeSettings {
  [NotificationType.INFO]: boolean;
  [NotificationType.SUCCESS]: boolean;
  [NotificationType.WARNING]: boolean;
  [NotificationType.ERROR]: boolean;
  [NotificationType.REMINDER]: boolean;
  [NotificationType.ALERT]: boolean;
  [NotificationType.ANNOUNCEMENT]: boolean;
  [NotificationType.SYSTEM]: boolean;
}

export interface QuietHours {
  enabled: boolean;
  startTime: string;
  endTime: string;
  timezone: string;
  days: number[];
}

export interface DigestSettings {
  enabled: boolean;
  frequency: DigestFrequency;
  time: string;
  types: NotificationType[];
}

export enum DigestFrequency {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

export interface NotificationDelivery {
  id: number;
  notificationId: number;
  channel: NotificationChannel;
  status: NotificationStatus;
  sentDate?: Date;
  deliveredDate?: Date;
  errorMessage?: string;
  retryCount: number;
  maxRetries: number;
}

export enum NotificationChannel {
  EMAIL = 'email',
  SMS = 'sms',
  PUSH = 'push',
  IN_APP = 'in_app',
  WEBHOOK = 'webhook',
}
